'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Tooltip = require('dibs-react-tooltip');
require('dibs-react-tooltip/dist/main.css');

// Stores
const PdpUiStore = require('../../stores/PdpUiStore.es');

// Components
const SocialIcon = require('../../../global/components/SocialIcon');
const PrintIcon = require('dibs-vg/dist/react/print');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const URL = require('../../../global/utils/commonjs/uri').URL;
const hasContextTypes = require('../../../global/reactHelpers/hasContextTypes');
const {trackPrint} = require('../../actions/pdpTrackingActions');


const PdpPrintIcon = React.createClass(hasContextTypes({
    getInitialState() {
        return {
            open: false
        };
    },

    _handleClick() {
        this.setState({ open: true });

        document.body.addEventListener('click', this._closeOnBodyClick);
    },

    _closeOnBodyClick(event) {
        if (!this._icon.contains(event.target)) {
            this.setState({ open: false });
            document.body.removeEventListener('click', this._closeOnBodyClick);
        }
    },

    _printWithPrice() {
        this.context.executeAction(trackPrint, { withPrice: true });
    },

    _printWithoutPrice() {
        this.context.executeAction(trackPrint, { withPrice: false });
    },

    render() {
        const { selectedImage } = this.props;
        const printNoPriceParam = 'print-view=no-price';
        const selectedImageParam = `?selected-image=${selectedImage}`;
        const printParam = selectedImage ? selectedImageParam : '';
        const printParamNoPrice = selectedImage ? `${selectedImageParam}&${printNoPriceParam}` : `?${printNoPriceParam}`;

        return (
            <div ref={icon => { this._icon = icon; }} className="pdp-print" data-tn="print">
                <SocialIcon onClick={this._handleClick} Icon={PrintIcon} iconName="print" />
                <Tooltip isVisible={this.state.open}
                    containerClass="pdp-print-tooltip"
                    tooltipDirection="bottom">
                    <div className="pdp-print-menu-item"><a href={`/print${URL.path}${printParam}`} rel="nofollow" target="_blank" onClick={this._printWithPrice}>Print</a></div>
                    <div className="pdp-print-menu-item"><a href={`/print${URL.path}${printParamNoPrice}`} rel="nofollow" target="_blank" onClick={this._printWithoutPrice}>Print without Price</a></div>
                </Tooltip>
            </div>
        );
    }
}));

PdpPrintIcon.propTypes = {
    selectedImage: PropTypes.number
};

module.exports = provideContext(connectToStores(
    PdpPrintIcon,
    [
        PdpUiStore
    ],
    context => {
        const uiStore = context.getStore(PdpUiStore);

        return { selectedImage: uiStore.getHeroCarouselIndex() };
    }
));



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpPrintIcon.jsx